
 
import { axiosRequest, AxiosRequestOptions } from "../api";
import  config from '../../config';


import {EssentialsOutput, OptionsQueryOutput } from '../../types/essentials';

export default  {
 
    
    essentials(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< EssentialsOutput >("GET",`${config.apiUrl.essentials}/EssentialsQuery/Essentials${queryParams || ""}`,undefined, options);
    },
 
    
    cachedClientVersions(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest  ("GET",`${config.apiUrl.essentials}/ManagerCore/CachedClientVersions${queryParams || ""}`,undefined, options);
    },
 
    
    invalidateClientVersionsCache(data : any, options?: AxiosRequestOptions) { 
        return axiosRequest  ("POST",`${config.apiUrl.essentials}/ManagerCore/InvalidateClientVersionsCache`,data, options);
    },
 
    
    optionsQuery(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< OptionsQueryOutput >("GET",`${config.apiUrl.essentials}/OptionsQuery/OptionsQuery${queryParams || ""}`,undefined, options);
    },

};